import React from 'react';
import {PopoverMenuOptionProps} from "./option";

export default function OptionText(props:PopoverMenuOptionProps) {

    const onClick = (e: React.SyntheticEvent) => {

        e.stopPropagation()

        if (!props.option.disabled) props.onClick(props.option);
    }

    const classes = Classes('option', {
        'highlighted': props.isHighlighted,
        disabled: props.option.disabled
    });

    const valueClass = Classes('label', {
        bold: props.isSelected,
    });

    return (
        <div className={classes} onClick={onClick}>
            {props.option.icon && <div className={Classes("ico", props.option.icon)}/>}
            <div className={valueClass}>{props.option.label}</div>
        </div>
    );

}
